module.exports = __webpack_public_path__ + "img/empty.14fb8377.png";